import { render, staticRenderFns } from "./ProgramManagementForm.vue?vue&type=template&id=a8fc33f2&"
import script from "./ProgramManagementForm.vue?vue&type=script&lang=js&"
export * from "./ProgramManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./ProgramManagementForm.vue?vue&type=style&index=0&id=a8fc33f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports